import { Group } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { exportSingleReport } from "../../../services/report";
import {
  useSelectAllSelected,
  useSelectFiltersSingleClientReport,
  useSelectSelected,
} from "../../../redux/features/reports/singleClientReportSlice";
import { formatFiltersReports } from "../singleReport/utils";
import { toast } from "react-toastify";
import { REPORT_EXPORT_TYPE, REPORT_TYPES } from "../constants";
import ExportFileButton from "../../../components/ExportFileButton/ExportFileButton";

const ExportSingleReports = ({ type }) => {
  const { t } = useTranslation();
  const selected = useSelectSelected();
  const allSelected = useSelectAllSelected();

  const [currentType, setCurrentType] = useState(null);

  const singleClientReportFilters = formatFiltersReports(
    useSelectFiltersSingleClientReport(),
  );

  const singleReportDownloadfile = useMutation({
    mutationKey: ["single-client-report-download-file"],
    mutationFn: (reportExportType) =>
      exportSingleReport({
        ...singleClientReportFilters,
        forExport: true,
        reportExportType,
        allSelected,
        ids: selected,
      }),
    onSuccess: (response) => {
      const fileName =
        response.headers["content-disposition"]?.split("filename=")[1];

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    },
    onError: ({ message }) => {
      toast.error("Export error " + message);
    },
  });

  const handleDownload = async (option) => {
    if (type === REPORT_TYPES.SINGLE) {
      setCurrentType(option);
      await singleReportDownloadfile.mutateAsync(option);
      setCurrentType(null);
    }
  };

  const loading = singleReportDownloadfile.isPending;
  const noRecordsSelected = !allSelected && selected.length === 0;

  return (
    <Group>
      <ExportFileButton
        handleDownload={() => handleDownload(REPORT_EXPORT_TYPE.PDF)}
        disabled={loading || noRecordsSelected}
        loading={loading && currentType === REPORT_EXPORT_TYPE.PDF}
        tooltipLabel={t("reports.exportPdf")}
        type={REPORT_EXPORT_TYPE.PDF}
      />
      <ExportFileButton
        handleDownload={() => handleDownload(REPORT_EXPORT_TYPE.EXCEL)}
        disabled={loading || noRecordsSelected}
        loading={loading && currentType === REPORT_EXPORT_TYPE.EXCEL}
        tooltipLabel={t("reports.exportExcel")}
        type={REPORT_EXPORT_TYPE.EXCEL}
      />
    </Group>
  );
};

export default ExportSingleReports;
